module.exports = __webpack_public_path__ + "static/oberhuber-jenal-logo-en-3fa4be1a27bcbca11891737dec00a18b.svg";